import React from 'react'
import axios from 'axios';
import utils from '../Utils';
import { Button } from '@material-ui/core';
import { blue } from '@material-ui/core/colors';
import { Link } from 'react-router-dom'
import Article from './Article'
import Loading from 'components/Loading'
import SnackBar from 'components/SnackBar'



import style from 'style/Article.css'

const coronaURL = 'https://www.tebinja.com/api/v1/blog/posts/search?q=%DA%A9%D8%B1%D9%88%D9%86%D8%A7'
class Articles extends React.Component {
  constructor(props) {
    super(props)
    this.state={
      loading: false,
      articles:[]
    }
  }
  componentDidMount() {
    this.fetchArticles()
  }
  fetchArticles = async () => {

    this.setState({ loading: true })
    let result = await axios.get(coronaURL).catch((e) => {
      // console.log(e.response)
      let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
      this.SnackBar.openSnackbar(message)
    });
    this.setState({ loading: false })

    if (!result) return
    // console.log(result, '###############')

    let { success, posts } = result.data;
    if (!success) return this.SnackBar.openSnackbar('خطایی پیش آمده است')
    this.setState({ articles: posts })


  }
  fullName = (patient) => {
    return patient.fname + ((patient.lname && patient.fname) && ' ') + patient.lname
  }
  showQuiz = (quizId) => {

  }
  renderArticles = () => {
    return (
      this.state.articles.map(article => {
        return (
          <Article article={article} key={article.id}></Article>
        )
      })
    )
  }
  render() {
    return (
      <div class="articles-container" style={{ ...this.props.style }}>
        <SnackBar ref={el => { this.SnackBar = el }}></SnackBar>

        <div class='articles-title'>
          تازه ترین مقالات کرونا
        </div>
        {this.state.loading && <Loading></Loading>}
        {!this.state.loading &&this.renderArticles()}
      </div>
    )
  }
}
export default Articles;